

import React, { useState, useContext } from 'react';


import { DataGridPro, useGridApiRef } from '@mui/x-data-grid-pro';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import { Link, Navigate, useNavigate } from "react-router-dom";
import Typography from '@mui/material/Typography';
import { format, formatISO } from 'date-fns'

import { IoMdArrowDropright, IoMdArrowDropdown } from "react-icons/io";

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import TextField from "@mui/material/TextField";


import { DateField } from '@mui/x-date-pickers/DateField';
import { DateTimeField } from '@mui/x-date-pickers/DateTimeField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'




function FamilyDetailsActivityLogTable({ tableData, desiredWidth, desiredHeight }) {

    const apiRef = useGridApiRef();

    const [mainSearchFilterModel, setMainSearchFilterModel] = React.useState([]);
    const [mainSearchFilterModelLogicalOperator, setMainSearchFilterModelLogicalOperator] = React.useState("");


    const [generateNewSearchFilterModel, setGenerateNewSearchFilterModel] = React.useState(false);


    if (desiredWidth == undefined || desiredWidth == null) {

    }

    const [searchValueActivityType, setSearchValueActivityType] = React.useState("");

    function handleSearchValueActivityTypeChange(event) {
        event.preventDefault();
        setSearchValueActivityType(event.target.value);



    }

    const [searchValueActivityComments, setSearchValueActivityComments] = React.useState("");

    function handleSearchValueActivityCommentsChange(event) {
        event.preventDefault();
        setSearchValueActivityComments(event.target.value);



    }


    const [searchValueActivityDateAndTime, setSearchValueActivityDateAndTime] = React.useState(null);

    function handleSearchValueActivityDateAndTimeChange(value) {

        

        if (value !== null) {

            setSearchValueActivityDateAndTime(value);
        }

        //setSearchValueActivityDateAndTime(event.target.value);



    }

    const [searchValueActivityUser, setSearchValueActivityUser] = React.useState("");

    function handleSearchValueActivityUserChange(event) {
        event.preventDefault();
        setSearchValueActivityUser(event.target.value);



    }

    const [searchValueActivityMember, setSearchValueActivityMember] = React.useState("");

    function handleSearchValueActivityMemberChange(event) {
        event.preventDefault();
        setSearchValueActivityMember(event.target.value);



    }

    const [searchValueActivityNotes, setSearchValueActivityNotes] = React.useState("");

    function handleSearchValueActivityNotesChange(event) {
        event.preventDefault();
        setSearchValueActivityNotes(event.target.value);



    }


    function handleGetAndSetAllFiltersForUpdate() {



        apiRef.current.setFilterModel({
            items: []

        });

        let newMainSearchFilterModel = [];
        let newLogicalSearchOperator = null;


        //if (searchValueDOB !== null) {
        //    let i = newMainSearchFilterModel?.length;
        //    let newItemID = i + 1;

        //    /*let convertedForSearchFilterDate = searchValueDOB;*/
        //    let convertedForSearchFilterDate = convertUserProvidedDate(searchValueDOB)
        //    console.log("ConvertedSearchDate: ", convertedForSearchFilterDate);

        //    const newSearchFilterModelItem = {
        //        id: newItemID,
        //        field: "date_of_birth",
        //        value: convertedForSearchFilterDate,
        //        operator: 'contains'
        //    };
        //    newMainSearchFilterModel = [...newMainSearchFilterModel, newSearchFilterModelItem];


        //}
    

        if (searchValueActivityType !== "") {
            let i = newMainSearchFilterModel?.length;
            let newItemID = i + 1;

            const newSearchFilterModelItem = {
                id: newItemID,
                field: 'activityLogType',
                value: searchValueActivityType,
                operator: 'contains'
            };
            newMainSearchFilterModel = [...newMainSearchFilterModel, newSearchFilterModelItem];



        }

        if (searchValueActivityComments !== "") {
            let i = newMainSearchFilterModel?.length;
            let newItemID = i + 1;

            const newSearchFilterModelItem = {
                id: newItemID,
                field: 'activityLogComments',
                value: searchValueActivityComments,
                operator: 'contains'
            };
            newMainSearchFilterModel = [...newMainSearchFilterModel, newSearchFilterModelItem];



        }

        if (searchValueActivityUser !== "") {
            let i = newMainSearchFilterModel?.length;
            let newItemID = i + 1;

            const newSearchFilterModelItem = {
                id: newItemID,
                field: "activityLogUser",
                value: searchValueActivityUser,
                operator: 'contains'
            };
            newMainSearchFilterModel = [...newMainSearchFilterModel, newSearchFilterModelItem];



        }

        if (searchValueActivityMember !== "") {
            let i = newMainSearchFilterModel?.length;
            let newItemID = i + 1;

            const newSearchFilterModelItem = {
                id: newItemID,
                field: "activityLogMember",
                value: searchValueActivityMember,
                operator: 'contains'
            };
            newMainSearchFilterModel = [...newMainSearchFilterModel, newSearchFilterModelItem];



        }

        if (searchValueActivityNotes !== "") {
            let i = newMainSearchFilterModel?.length;
            let newItemID = i + 1;

            const newSearchFilterModelItem = {
                id: newItemID,
                field: "activityLogNotes",
                value: searchValueActivityNotes,
                operator: 'contains'
            };
            newMainSearchFilterModel = [...newMainSearchFilterModel, newSearchFilterModelItem];



        }

        if (searchValueActivityDateAndTime !== null) {
            let i = newMainSearchFilterModel?.length;
            let newItemID = i + 1;

            /*let convertedForSearchFilterDate = searchValueDOB;*/
            let convertedForSearchFilterDate = convertUserProvidedDate(searchValueActivityDateAndTime)
            console.log("ConvertedSearchDate: ", convertedForSearchFilterDate);

            const newSearchFilterModelItem = {
                id: newItemID,
                field: "activityLogDateTimeIncurred",
                value: convertedForSearchFilterDate,
                //value: Date.parse(searchValueAuditEndDate).toString(),
                operator: 'contains'
            };
            newMainSearchFilterModel = [...newMainSearchFilterModel, newSearchFilterModelItem];


        }

        handleUpdateMainSearchFilterModel(newMainSearchFilterModel, newLogicalSearchOperator)





    }


    function handleUpdateMainSearchFilterModel(newMainSearchFilterModel, newLogicalOperator) {



        if (newMainSearchFilterModel !== null) {
            //let newMainSearchFilterModel = mainSearchFilterModel;


            //let i = newMainSearchFilterModel?.length;
            //let newItemID = i + 1;

            //let newParameterFieldType = newFilterParameter?.FieldType;
            //let newParameterSearchValue = newFilterParameter?.SearchValue;
            //let newParameterOperatorValue = newFilterParameter?.OperatorValue;

            //let newSearchFilterModelItem = {
            //    id: newItemID,
            //    operator: newParameterOperatorValue,
            //    field: newParameterFieldType,
            //    value: newParameterSearchValue,
            //}
            if (newLogicalOperator !== null) {
                setMainSearchFilterModelLogicalOperator(newLogicalOperator)
                setMainSearchFilterModel(newMainSearchFilterModel);
                console.log("SETTING NEW APIREF - WITH LOGICAL OPERATOR: ", newMainSearchFilterModel)
                apiRef.current.setFilterModel({
                    items: newMainSearchFilterModel,
                    logicOperator: newLogicalOperator

                });
            } else {
                setMainSearchFilterModel(newMainSearchFilterModel);
                console.log("SETTING NEW APIREF: ", newMainSearchFilterModel)
                apiRef.current.setFilterModel({
                    items: newMainSearchFilterModel

                });
            }
            /////
            //if (newMainSearchFilterModel !== []) {
            //    handleUpdatePreviousSearchParameters(newMainSearchFilterModel)
            //    if (newLogicalOperator !== null) {
            //        handleUpdatePreviousSearchLogicalOperatorParameter(newLogicalOperator)
            //    }

            //}

            //newMainSearchFilterModel = [...newMainSearchFilterModel, newSearchFilterModelItem];
            //if (generateNewSearchFilterModel == true) {


        } else if (newMainSearchFilterModel == null) {
            setMainSearchFilterModel([]);
            apiRef.current.setFilterModel({
                items: []

            });
            console.log("SETTING NEW APIREF NULL: ", null)

            setSearchValueActivityType("")
            setSearchValueActivityComments("")
            setSearchValueActivityDateAndTime(null);
            setSearchValueActivityUser("")
            setSearchValueActivityMember("")
            setSearchValueActivityNotes("")


           



            setGenerateNewSearchFilterModel(false)
        }
        //console.log("PREV SEARCH MODEL:", previousSearchParameters);
        //console.log("PREV SEARCH LOGICAL OPERATOR:", previousSearchLogicalOperatorParameter);
    }


    function handleGenerateNewMainSearchFilterModel() {
        /* setGenerateNewSearchFilterModel(true)*/
        setMainSearchFilterModel([])
        apiRef.current.setFilterModel({
            items: []

        });



        handleGetAndSetAllFiltersForUpdate()
    }


    //function renderDate(date) {
    //    if (!date) {
    //        return '';
    //    }
    //    return format(new Date(date), 'MM/dd/yyyy');
    //}



    function convertUserProvidedDate(date) {

        console.log("Passed in date value to be converted: ", date);
        console.log("Passed in aDaT value to be converted: ", searchValueActivityDateAndTime);

        let test = Date.parse(searchValueActivityDateAndTime).toString();

        console.log("Parsed: date", test);


        if (!date) {
            return '';
        }


        //return format(new Date(date), 'M/dd/yyyy');


        return Date.parse(searchValueActivityDateAndTime).toString();

        /* formatISO(new Date(date), { representation: 'date' })*/
    }


    function handleClearSearchAndBackUpPreviousFilterModel() {
        console.log("CLEAR SEARCH AND BACK UP");
        //backup relevant values
        if (mainSearchFilterModel !== []) {

            if (mainSearchFilterModelLogicalOperator !== null) {




            }




        }
        //then clear out the existing
        handleUpdateMainSearchFilterModel(null);
    }

    //let mock_dependent_findings = [

    //    { rowID: 0, auditFindingTitle: "Audit Finding 1", auditFindingText: "As part of this verification, a certified marriage certificate (registered to County/State) is required. A marriage license and church document are not acceptable." },
    //    { rowID: 1, auditFindingTitle: "Audit Finding 2", auditFindingText: "The joint document submitted does not meet the requirements of the audit. A current joint document is required to verify the relationship to this dependent. The joint document must be addressed to both the employee and the spouse and is dated within the past 90 days." },
    //    { rowID: 2, auditFindingTitle: "Audit Finding 3", auditFindingText: "As part of this verification, a certified marriage certificate (registered to County/State) is required. A marriage license and church document are not acceptable." },
    //    { rowID: 3, auditFindingTitle: "Audit Finding 4", auditFindingText: "The joint document submitted does not meet the requirements of the audit. A current joint document is required to verify the relationship to this dependent. The joint document must be addressed to both the employee and the spouse and is dated within the past 90 days." },
    //    { rowID: 4, auditFindingTitle: "Audit Finding 5", auditFindingText: "As part of this verification, a certified marriage certificate (registered to County/State) is required. A marriage license and church document are not acceptable." },
    //    { rowID: 5, auditFindingTitle: "Audit Finding 6", auditFindingText: "The joint document submitted does not meet the requirements of the audit. A current joint document is required to verify the relationship to this dependent. The joint document must be addressed to both the employee and the spouse and is dated within the past 90 days." },
    //    { rowID: 6, auditFindingTitle: "Audit Finding 7", auditFindingText: "As part of this verification, a certified marriage certificate (registered to County/State) is required. A marriage license and church document are not acceptable." },
    //    { rowID: 7, auditFindingTitle: "Audit Finding 8", auditFindingText: "The joint document submitted does not meet the requirements of the audit. A current joint document is required to verify the relationship to this dependent. The joint document must be addressed to both the employee and the spouse and is dated within the past 90 days." },
    //    { rowID: 8, auditFindingTitle: "Audit Finding 9", auditFindingText: "As part of this verification, a certified marriage certificate (registered to County/State) is required. A marriage license and church document are not acceptable." },

    //]

    //from mui documentation

    function stringToColor(string) {
        let hash = 0;
        let i;

        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = '#';

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */

        return color;
    }

    function stringAvatar(name) {
        if (name !== undefined) {

            return {
                sx: {
                    //bgcolor: '#737373',
                    bgcolor: '#23549F',
                    color: '#FFFFFF',
                    fontSize: 12
                },
                children: `${name.substring(0, 3)}`,
            };
        }
    }

    function renderDate(date) {
        if (!date) {
            return '';
        }
        return format(new Date(date), 'MM/dd/yyyy h:mm:ss a');
    }

    function renderRelationship(row) {
        console.log("ROW -----", row);
        if (row === "E") {
            return 'Employee'
        }
        else if (row === "S ") {
            return 'Spouse'
        } else if (row === "D ") {
            return 'Dependent'
        } else {
            return `${row}`
        }
    }

    function renderMemberStatus(dataText) {
        if (dataText == "Passed") {
            return (<Chip sx={{ bgcolor: '#BBF7D0', color: '#166534' }} label={dataText} />)
        } else if (dataText == "Incomplete") {
            return (<Chip sx={{ bgcolor: '#FDE68A', color: '#92400E' }} label={dataText} />)
        } else if (dataText == "Ineligible") {
            return (<Chip sx={{ bgcolor: '#FECACA', color: '#991B1B', }} label={dataText} />)
        } else if (dataText == null) {
            return (<Chip sx={{ bgcolor: '#FECACA', color: '#991B1B', }} label={'DB: NULL'} />)
        } else {
            return (<Chip label={dataText} />)
        }
    }



    const rows = tableData;
    const navigate = useNavigate();

    const columns = [

        {
            "field": "activityLogType",
            "headerName": "Type",
            "width": 250,
            "editable": false
        },
        {
            "field": "activityLogComments",
            "headerName": "Comments",
            "width": 250,
            "editable": false
        },
        {
            "field": "activityLogDateTimeIncurred",
            "headerName": "Date/Time",
            "width": 240,
            "editable": false,
            renderCell: (params) =>
                renderDate(params.row?.activityLogDateTimeIncurred)
        },
        {
            "field": "activityLogUser",
            "headerName": "User",
            "width": 200,
            "editable": false,       },
        {
            "field": "activityLogMember",
            "headerName": "Member",
            "width": 250,
            "editable": false
        },
        {
            "field": "activityLogNotes",
            "headerName": "Notes",
            "width": 250,
            "editable": false,
          
        },
       

    ];

    function getEmployeeRowID(row) {
        return row?.rowID;
    }

    return (
        <>
            {desiredWidth ? (<>
               
                <Box sx={{ width: '98VW', bgcolor: '#FAFAFA', mt: 0, ml: 0,mb: 2, display: { xs: 'none', md: 'block', xl: 'block' } }}>
                    < TextField
                        label="Type"
                        variant="outlined"
                        value={searchValueActivityType}
                        onChange={handleSearchValueActivityTypeChange}

                        sx={{ ml: 0, mr: '1VW', width: '8.75VW', bgcolor: '#FFFFFF' }
                        }


                    />

                   


                    < TextField
                        label="Comments"
                        variant="outlined"
                        value={searchValueActivityComments}
                        onChange={handleSearchValueActivityCommentsChange}

                        sx={{ mr: '1VW', width: '10VW', bgcolor: '#FFFFFF' }}


                    />

                    {/*< LocalizationProvider dateAdapter={AdapterDayjs} >*/}
                    {/*    < DateTimeField*/}
                    {/*    label="Date/Time"*/}
                    {/*        variant="outlined"*/}
                            
                    {/*        value={searchValueActivityDateAndTime}*/}
                    {/*        onChange={(value) => handleSearchValueActivityDateAndTimeChange(value)}*/}
                    {/*    //onChange={handleSearchValueActivityDateAndTimeChange}*/}

                    {/*    sx={{ mr: '1VW', width: '14VW', bgcolor: '#FFFFFF' }*/}
                    {/*    }*/}


                    {/*/>*/}
                    {/*</LocalizationProvider >*/}



                    < TextField
                        label="User"
                        variant="outlined"
                        value={searchValueActivityUser}
                        onChange={handleSearchValueActivityUserChange}

                        sx={{ mr: '1VW', width: '8.75VW', bgcolor: '#FFFFFF' }}


                    />

                    < TextField
                        label="Member"
                        variant="outlined"
                        value={searchValueActivityMember}
                        onChange={handleSearchValueActivityMemberChange}

                        sx={{ mr: '1VW', width: '8.75VW', bgcolor: '#FFFFFF' }}


                    />


                    < TextField
                        label="Notes"
                        variant="outlined"
                        value={searchValueActivityNotes}
                        onChange={handleSearchValueActivityNotesChange}

                        sx={{ mr: '1VW', width: '8.75VW', bgcolor: '#FFFFFF' }}


                    />


                

                <Button
                    variant="contained"
                    label="GENERATE SEARCH"
                    sx={{ mr: '1VW', height: '5VH', bgcolor: '#3B82F6' }}
                        onClick={() => handleGenerateNewMainSearchFilterModel()}
                >
                    GENERATE SEARCH
                    </Button>

                    <>
                        <Button
                            sx={{
                                maxWidth: '1VW', height: '6VH', bgcolor: '#FFFFFF', color: '#991B1B', border: '1px solid #991B1B',
                                '&:hover': {
                                    cursor: 'pointer',
                                    bgcolor: '#FECACA'
                                }
                            }}
                            aria-label="more"
                            id="long-button"
                            aria-haspopup="true"
                            onClick={() => handleClearSearchAndBackUpPreviousFilterModel()}
                        >
                            X

                            {/* <CgOptions />*/}
                        </Button>

                    </>
                </Box>
                <div style={{ width: desiredWidth, height: desiredHeight, }}>
                 


                    <DataGridPro
                        getRowId={getEmployeeRowID}
                        disableSelectionOnClick={true}
                        disableMultipleRowSelection={true}
                        apiRef={apiRef}
                        rows={rows}
                        columns={columns}

                        sx={{
                            cursor: 'pointer',
                            '.MuiDataGrid-columnSeparator': {
                                display: 'none',
                            },
                            '&.MuiDataGrid-root': {
                                border: 'none',
                            },
                            '.MuiDataGrid-columnHeaderTitle': {
                                fontWeight: 'bold !important',
                                overflow: 'visible !important'
                            }
                        }}
                       
                    />
                </div>
            </>) : (<>
                <div style={{ height: 550, width: "70VW" }}>
                    <DataGridPro
                        getRowId={getEmployeeRowID}
                        disableSelectionOnClick={true}
                        disableMultipleRowSelection={true}
                            apiRef={apiRef}
                        rows={rows}
                        columns={columns}

                        sx={{
                            cursor: 'pointer',
                            '.MuiDataGrid-columnSeparator': {
                                display: 'none',
                            },
                            '&.MuiDataGrid-root': {
                                border: 'none',
                            },
                            '.MuiDataGrid-columnHeaderTitle': {
                                fontWeight: 'bold !important',
                                overflow: 'visible !important'
                            }
                        }}
                       



                    />
                </div>
            </>)}
        </>
    );
}

export default FamilyDetailsActivityLogTable;